import * as React from 'react';
import styled from "styled-components";
import Continents from './Continents';
import PlanetMask from './PlanetMask';
import StarField from './StarField';
import PointsOfInterest from './PlacesOfInterest';
import Textures from './Textures';
import Gaseous from './Gaseous';
import Radar from './Radar';
import BarGraph from './BarGraph';

const OuterContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 1fr);
  border: 1px solid ${(props) => props.theme.primaryColor};
  overflow: none;
  width:100%;
`

const StyledTextures = styled(Textures)`
  stroke-width: 2px;
  fill: none;
  grid-area: 1 / 1 / 5 / 5;
  vector-effect: non-scaling-stroke;
  z-index: 0;
`

const StyledContinents = styled(Continents)`
  stroke-width: 4px;
  grid-area: 1 / 1 / 5 / 5;
  vector-effect: non-scaling-stroke;
  z-index: 2;
`

const StyledGaseous = styled(Gaseous)`
  stroke-width: 10px;
  grid-area: 1 / 1 / 5 / 5;
`

const StyledMask = styled(PlanetMask)`
  width: 100%;
  stroke-width: var(--planet-stroke);
  grid-area: 1 / 1 / 5 / 5;
  fill: ${(props) => props.theme.backgroundColor};
  vector-effect: non-scaling-stroke;
  z-index: 3;
`

const StyledStars = styled(StarField)`
  fill: ${(props) => props.theme.primaryColor};
  grid-area: 1 / 1 / 5 / 5;
  z-index: 4;
`

const StyledPlaces = styled(PointsOfInterest)`
  grid-area: 1 / 1 / 5 / 5;
  z-index: 10;
`

const Overlay = styled.div`
  width: 90%;
`

const LowerLeft = styled(Overlay)`
  grid-area: 4 / 1 / 5 / 2;
  z-index: 6;
`

const LowerRight = styled(Overlay)`
  grid-area: 4 / 4 / 5 / 5;
  z-index: 6;
`

const PlanetImage = ({planetViewbox, planetColors, starNum, poiNums, textureNum, gaseous, orbitalTag, hasWater, blockade}) => {
  const backgroundStyle = {
    backgroundColor: planetColors.background,
  }
  return (
    <OuterContainer style={backgroundStyle} alt={`A dramatic sci-fi ${gaseous ? 'gaseous' : 'terrestial'} planet`}>
      {gaseous ?
        <StyledGaseous stroke={planetColors.texture} viewBox={planetViewbox} fill={planetColors.ocean} /> :
        <>
          <StyledTextures stroke={planetColors.texture} numbers={textureNum} />
          {hasWater && <StyledContinents viewBox={planetViewbox} fill={planetColors.ocean} stroke={planetColors.highlight} />}
        </>
      }
      <StyledMask stroke={planetColors.highlight} />
      <StyledStars num={starNum} />
      <StyledPlaces
        gaseous={gaseous}
        poiNums={poiNums}
        fill={planetColors.highlight}
        stroke={planetColors.highlight}
        planetcolors={planetColors}
        orbitalTag={orbitalTag}
        blockade={blockade} />
      <LowerLeft><Radar /></LowerLeft>
      <LowerRight><BarGraph /></LowerRight>
    </OuterContainer>
  )
}

export default PlanetImage;
